export default __webpack_public_path__ + "static/media/sibling-rivalry@2x 2.6befbd68.png";